
    import './styles.scoped.css';
    export default {
  "option": "awsui_option_1p2cx_nby9z_17",
  "disabled": "awsui_disabled_1p2cx_nby9z_54",
  "parent": "awsui_parent_1p2cx_nby9z_57",
  "highlighted": "awsui_highlighted_1p2cx_nby9z_60",
  "content": "awsui_content_1p2cx_nby9z_64",
  "label-content": "awsui_label-content_1p2cx_nby9z_71",
  "label": "awsui_label_1p2cx_nby9z_71",
  "tag": "awsui_tag_1p2cx_nby9z_78",
  "label-tag": "awsui_label-tag_1p2cx_nby9z_79",
  "label-prefix": "awsui_label-prefix_1p2cx_nby9z_89",
  "single-line": "awsui_single-line_1p2cx_nby9z_102",
  "tags": "awsui_tags_1p2cx_nby9z_121",
  "description": "awsui_description_1p2cx_nby9z_122",
  "selected": "awsui_selected_1p2cx_nby9z_133",
  "icon": "awsui_icon_1p2cx_nby9z_147",
  "filtering-match-highlight": "awsui_filtering-match-highlight_1p2cx_nby9z_154",
  "trigger-variant": "awsui_trigger-variant_1p2cx_nby9z_169",
  "custom-content": "awsui_custom-content_1p2cx_nby9z_175"
};
  